import {connect} from "react-redux"
import {State} from "../../ducks"

export const mapStateToProps = (state: State) => {
    const {simpleSearchEnabled, enrichedSearchEnabled} = state.settings
    return {
        simpleSearchEnabled,
        enrichedSearchEnabled,
        closeText: state.text.searchBox.closeButton.text,
        templating: state.template,
    }
}

export default connect(mapStateToProps)
